// extracted by mini-css-extract-plugin
export default {"container":"WordGameLayout_container__64iSM","sub_container":"WordGameLayout_sub_container__3gAer"};